<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'cases_category',
      key: 'category_id',
      items: [
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        // {
        //   label: "分类",
        //   name: "type",
        //   value: 1,
        //   type: "select",
        //   dropList: [
        //     { value: 1, name: "回收类型" },
        //     { value: 2, name: "重量类型" },
        //   ],
        //   onChange: this.onSelect,
        // },
        { label: '标题', name: 'name', value: '', type: 'input', rules: [{ required: true, trigger: 'blur' }] },
        { label: '副标题', name: 'sname', value: '', type: 'input', rules: [{ required: true, trigger: 'blur' }] },
        // { label: '图标', name: 'icon', value: '', type: 'image', desc: '建议图片宽高尺寸512*512像素及以上', rules: [{ required: false, trigger: 'blur' }] },
        {label: '图片', name: 'image', value: '',  type: 'image', desc: '建议图片宽高尺寸977*505像素及以上', rules: [{ required: false, trigger: 'blur' }]},
        // { label: '描述', name: 'content', value: '', type: 'textarea' },
        { label: '状态', name: 'status', value: 1, type: 'switch', trueValue: 1, falseValue: 2 },
      ],
      forms: {
        type:this.$route.query.type
      },
    }
  },
  created() {
    let query = this.$route.query;
    this.action = query.action;
    this.type = query.type;
    console.log("this.type",this.type)
  },
  methods: {},
}
</script>
